export default {
    module: {
        main_menu: 'Главное меню',
        categories: 'Категории'
    }
}
